import React, { PureComponent, Fragment, createRef } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import firebase from 'firebase/app'

import storage, { removeBlob } from '../helpers/storage'


export default class Upload extends PureComponent {
  /* LIFECYCLE */

  /**
   * @constructor
   * @param {*} props - Properties of the PureComponent
   */
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
    }

    this.input = createRef()
  }

  /**
   * @componentWillUnmount
   */
  componentWillUnmount() {
    const { value, autoRemoveBlob } = this.props

    if (value && autoRemoveBlob) {
      removeBlob(value)
    }
  }


  /* METHODS */

  getPathByType = () => {
    const {
      uid,
      type,
    } = this.props

    switch (type) {
      case 'casting': return '/castings/'
      case 'user_profile': return `/users/images/${uid}/folio/`
      default: return `/others/${uid}/`
    }
  }

  /**
   * Open the input
   */
  handleOpenInput = () => {
    const { current } = this.input

    if (current) {
      current.click()
    }
  }

  /**
   * When upload new file
   */
  handleFileChange = async (e) => {
    e.preventDefault()
    const {
      uid,
      name,
      type,
      onChange,
    } = this.props
    const fileId = uuid.v4()
    const file = e.target.files[0]
    const extension = file.name.split('.').pop()
    const path = `${this.getPathByType()}/${fileId}.${extension}`
    const metadata = {}

    if (type === 'user_profile') {
      metadata.id = uid
      metadata.type = 'user_profile'
    }

    try {
      this.setState({ isLoading: true })
      const response = await storage.put(path, file, file.type, metadata)
      const value = await response.getDownloadURL()

      if (type === 'user_profile') {
        const image = new Image()
        const reader = new FileReader()

        await new Promise((resolve) => {
          image.onload = async () => {
            await firebase.firestore().collection('users').doc(uid).collection('folio').doc(fileId).set({
              original: value,
              width: image.width,
              height: image.height,
            }, { merge: true })

            resolve()
          }

          reader.onload = event => image.src = event.target.result
          reader.readAsDataURL(file);
        })
      }

      this.setState({ isLoading: false })
      onChange({
        target: {
          name,
          value,
        },
      })
    } catch (err) {
      console.warn(err)
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      name,
      accept,
      component,
    } = this.props
    const {
      isLoading,
    } = this.state

    return (
      <Fragment>
        <input
          value=""
          type="file"
          name={name}
          accept={accept}
          ref={this.input}
          className="hidden"
          onChange={this.handleFileChange}
        />
        {component({
          isLoading,
          onClick: this.handleOpenInput,
        })}
      </Fragment>
    )
  }
}


Upload.defaultProps = {
  type: null,
  withType: true,
  accept: 'image/*',
  autoRemoveBlob: false,
}


Upload.propTypes = {
  uid: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  accept: PropTypes.string,
  withType: PropTypes.bool,
  autoRemoveBlob: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  component: PropTypes.func.isRequired,
  visibility: PropTypes.oneOf(['public', 'protected', 'private']),
}
